module.exports = __webpack_public_path__ + "static/media/1013978.ba43441b.png";